import React from 'react';
import { Segment, Header } from 'semantic-ui-react';

export default (props) => {
    var {title, title_2} = props;
    return (
        <Segment style={{padding: 0, margin: 0}} textAlign="center" className="prize-label-container" basic>
            <Header style={{fontWeight: 300}}>
                <span>{title} <span style={{color: "#E2231A", fontWeight: 700}}>{title_2}</span></span>
            </Header>
        </Segment>
    )
}


// WEBPACK FOOTER //
// ./src/components/prizes/PrizeContainerTitle.jsx